// Entities
import type {
  CottageContactWhatsAppPagePricesDates,
  CottageContactWhatsAppPagePricesPeople,
  CottageContactWhatsAppPagePricesResponse,
} from '../entities/CottageContactWhatsAppPagePrices'
import type { CottageContactWhatsAppPage } from '../entities/CottageContactWhatsAppPage'

// Endpoints
import { browserFetch as getPrice } from '~~/modules/api/rurality/v3/cottages/price'
import { type paramsType } from '~~/shared/api/rurality/v3/cottages/price/schema'

type responseType = CottageContactWhatsAppPagePricesResponse | null

export function useCottageContactWhatsAppPagePrices() {
  async function getPricesData(params: {
    CottageContactWhatsAppPage: Pick<CottageContactWhatsAppPage, 'id'>
    dates: CottageContactWhatsAppPagePricesDates
    people: CottageContactWhatsAppPagePricesPeople | null
  }): Promise<responseType> {
    const responseCottagePage: responseType = {
      label: null,
      value: null,
      message: null,
    }
    const startString = toRuralityDate().apiDate(params.dates.start as Date)
    const endString = toRuralityDate().apiDate(params.dates.end as Date)

    const queryParams: paramsType = {
      id: params.CottageContactWhatsAppPage.id,
      numPeople: params.people,
      dateIn: startString,
      dateOut: endString,
    }

    const contactResponse = await getPrice(queryParams)

    if (contactResponse?.success) {
      const fetchData = contactResponse.success.data

      if (fetchData && fetchData.price !== null && fetchData.type !== null) {
        if (fetchData.type) {
          responseCottagePage.value = fetchData.price.amount

          if (fetchData.type === 'exact') {
            responseCottagePage.label = t(
              'views.cottage-contact-whatsapp.price.total',
            )
          } else if (fetchData.type === 'from') {
            responseCottagePage.label = t(
              'views.cottage-contact-whatsapp.price.from',
            )
          }
        }
      } else if (fetchData.price === null && fetchData.type === null) {
        responseCottagePage.message = t(
          'views.cottage-contact-whatsapp.price.emptyMessage',
        )
      }
    } else if (contactResponse.error) {
      responseCottagePage.message = t(
        'views.cottage-contact-whatsapp.price.errorMessage',
      )
    }

    return responseCottagePage
  }

  return {
    getPricesData,
  }
}
